import { IconType } from 'react-icons';
import { __BrandDetailLang } from './brandDetail.lang';
import { RiDiscountPercentFill } from 'react-icons/ri';
import { GiTrophyCup } from 'react-icons/gi';
import { FaUserTie } from 'react-icons/fa6';
import { __BrandSectionEnum } from './brandDetail.type';

export const __BrandSections: (
    lang: typeof __BrandDetailLang,
) => { title: string; slug: __BrandSectionEnum; icon: IconType }[] = (lang) => [
    { title: lang.company_services, slug: __BrandSectionEnum.services, icon: RiDiscountPercentFill },
    { title: lang.ranking, slug: __BrandSectionEnum.ranking, icon: GiTrophyCup },
    { title: lang.hiring, slug: __BrandSectionEnum.hiring, icon: FaUserTie },
];
